import { MAPPINGS, getMarkerSize, plotHoverLabel } from "api/styleSettings/processors";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createPlotData = (plotData: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  plotData.forEach((e: any) => {
    e.textposition = MAPPINGS.positions[e?.crossPlotPointOption?.positionType - 1]?.plotValue || 'bottom center'
    e.textfont = {
      family: e?.crossPlotPointOption?.font || 'Arial',
      size: e?.crossPlotPointOption?.fontSizeType,
      color: '#000'
    }

    // The colour comes from the API rather than the point option: the global imputed series has no
    // identifier field to have saved one against, and an imputed user point is already drawn in the
    // colour its field resolved to. The star is not in MAPPINGS.shape, which is the list of shapes
    // users can pick for real data.
    const imputedColor = e.isImputed ? e.marker?.color : undefined

    e.marker = {
      color: imputedColor ?? e.crossPlotPointOption?.stringColor,
      opacity: e.crossPlotPointOption?.opacity ?? 1,
      size: getMarkerSize(e.crossPlotPointOption?.markerSizeType),
      symbol: e.isImputed
        ? 'star'
        : MAPPINGS.shape[e?.crossPlotPointOption?.shapeType as number - 1]?.plotValue,
      line: {
        color: e?.crossPlotPointOption?.hasBorder ? '#000' : imputedColor ?? e.crossPlotPointOption?.stringColor,
        width: 1.5
      }
    }
    e.hoverlabel = plotHoverLabel()
  })
  return plotData;
}


